import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const withdrawalSchema = z.object({
  /** Currency */
  ccy: z.string(),
  /** Chain name */
  chain: z.string(),
  /** Whether it is a non-tradable asset or not */
  nonTradableAsset: z.boolean(),
  /** Withdrawal amount */
  amt: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Time the withdrawal request was submitted, Unix timestamp format in milliseconds */
  ts: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** Withdrawal account */
  from: z.string(),
  /** Area code for the phone number / If from is a phone number, this parameter return area code of the phone number */
  areaCodeFrom: z.string(),
  /** Receiving address */
  to: z.string(),
  /** Area code for the phone number / If to is a phone number, this parameter returns the area code for the phone number */
  areaCodeTo: z.string(),
  /** Some currencies require a tag for withdrawals. This is not returned if not required. */
  tag: z.string().optional(),
  /** Some currencies require a payment ID for withdrawals. This is not returned if not required. */
  pmtId: z.string().optional(),
  /** Some currencies require this parameter for withdrawals. This is not returned if not required. */
  memo: z.string().optional(),
  /** Withdrawal address attachment (This will not be returned if the currency does not require this) e.g. TONCOIN attached tag name is comment, the return will be {'comment':'123456'} */
  addrEx: z.unknown(),
  /** Hash record of the withdrawal */
  txId: z.string(),
  /** Withdrawal fee amount */
  fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Withdrawal fee currency */
  feeCcy: z.string(),
  /** Status of withdrawal */
  state: z.string(),
  /** Withdrawal ID */
  wdId: z.string(),
  /** Client-supplied ID */
  clientId: z.string(),
})

export type Withdrawal = z.infer<typeof withdrawalSchema>
